import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AutocompletarProductos } from './LiquidacionVales';

// Definir constantes dentro del archivo
const motivosDevolucion = {
  1: { texto: "Cambio de Precio", color: "#FF9800" },
  3: { texto: "Dañado", color: "#F44336" },
  4: { texto: "Devolución Cliente", color: "#9C27B0" },
  5: { texto: "Exceso Inventario", color: "#3F51B5" },
  6: { texto: "Fecha Vencimiento", color: "#2196F3" },
  9: { texto: "Vencido", color: "#607D8B" },
  11: { texto: "Otro", color: "#795548" }
};

const ModalRecepcion = ({ devolucion, onClose, onConfirmarRecepcion, productosCatalogo }) => {
  const { user } = useSelector(state => state.auth);
  const [productosRecepcion, setProductosRecepcion] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [mostrarAutocompletar, setMostrarAutocompletar] = useState({});
  const [productoEditando, setProductoEditando] = useState(null);

  // Inicializar los datos de recepción
  useEffect(() => {
    if (devolucion && devolucion.DEV_DET) {
      const productosIniciales = devolucion.DEV_DET.map(producto => ({
        ...producto,
        ID_Producto_Original: producto.ID_Producto,
        ItemName_Original: producto.ItemName,
        ID_Producto_Recepcion: producto.ID_Producto,
        ItemName_Recepcion: producto.ItemName,
        cantidadOriginal: producto.Cantidad,
        cantidadRecepcion: producto.Cantidad,
        observaciones: '',
        modificado: false,
        tipo: 'original',
        mostrarAutocompletar: false,
        editando: false
      }));
      setProductosRecepcion(productosIniciales);
    }
  }, [devolucion]);

  const handleCantidadChange = (idProducto, nuevaCantidad) => {
    setProductosRecepcion(prev =>
      prev.map(producto =>
        producto.ID_Devolucion_Detalle === idProducto
          ? { 
              ...producto, 
              cantidadRecepcion: parseInt(nuevaCantidad) || 0,
              modificado: nuevaCantidad !== producto.cantidadOriginal || producto.modificado
            }
          : producto
      )
    );
  };

  const handleObservacionesChange = (idProducto, observaciones) => {
    setProductosRecepcion(prev =>
      prev.map(producto =>
        producto.ID_Devolucion_Detalle === idProducto
          ? { ...producto, observaciones }
          : producto
      )
    );
  };

  const handleProductoChange = (idProducto, nuevoProducto) => {
    setProductosRecepcion(prev =>
      prev.map(producto =>
        producto.ID_Devolucion_Detalle === idProducto
          ? { 
              ...producto, 
              ID_Producto_Recepcion: nuevoProducto.ID_Producto,
              ItemName_Recepcion: nuevoProducto.ItemName,
              Lote: nuevoProducto.Lote || producto.Lote,
              Fecha_Vencimiento: nuevoProducto.Fecha_Vencimiento || producto.Fecha_Vencimiento,
              modificado: true,
              editando: false
            }
          : producto
      )
    );
    setProductoEditando(null);
  };

  const iniciarEdicionProducto = (idProducto) => {
    setProductoEditando(idProducto);
  };

  const cancelarEdicionProducto = () => {
    setProductoEditando(null);
  };

  const agregarLinea = () => {
    const nuevaLinea = {
      ID_Devolucion_Detalle: `nuevo-${Date.now()}`,
      ID_Producto_Original: null,
      ItemName_Original: null,
      ID_Producto_Recepcion: '',
      ItemName_Recepcion: '',
      cantidadOriginal: 0,
      cantidadRecepcion: 1,
      observaciones: '',
      Lote: '',
      Fecha_Vencimiento: '',
      ID_Motivo_Devolucion: 11,
      modificado: false,
      tipo: 'nuevo',
      editando: true
    };
    setProductosRecepcion(prev => [...prev, nuevaLinea]);
    setProductoEditando(nuevaLinea.ID_Devolucion_Detalle);
  };

  const eliminarLinea = (idProducto) => {
    if (idProducto.toString().startsWith('nuevo-')) {
      setProductosRecepcion(prev => prev.filter(p => p.ID_Devolucion_Detalle !== idProducto));
      if (productoEditando === idProducto) {
        setProductoEditando(null);
      }
    }
  };

  const handleConfirmar = async () => {
    setCargando(true);
    try {
      // Preparar el JSON para enviar a la API
      const datosRecepcion = {
        ID_Vale: devolucion.ID_Vale,
        ID_Devolucion: devolucion.ID_Devolucion,
        productos: productosRecepcion.map(producto => ({
          ID_Devolucion_Detalle: producto.tipo === 'nuevo' ? null : producto.ID_Devolucion_Detalle,
          ID_Producto_Original: producto.ID_Producto_Original,
          ID_Producto_Recepcion: producto.ID_Producto_Recepcion,
          ItemName_Original: producto.ItemName_Original,
          ItemName_Recepcion: producto.ItemName_Recepcion,
          cantidadOriginal: producto.cantidadOriginal,
          cantidadRecepcion: producto.cantidadRecepcion,
          observaciones: producto.observaciones,
          lote: producto.Lote,
          fechaVencimiento: producto.Fecha_Vencimiento,
          motivoDevolucion: producto.ID_Motivo_Devolucion,
          modificado: producto.modificado,
          tipo: producto.tipo
        })),
        fechaRecepcion: new Date().toISOString(),
        usuario: user.id_usuario || 'Sistema'
      };

      console.log('Datos de recepción a enviar:', datosRecepcion);
      await onConfirmarRecepcion(datosRecepcion);

    } catch (error) {
      console.error('Error al confirmar recepción:', error);
      throw error;
    } finally {
      setCargando(false);
    }
  };

  const totalProductosOriginal = productosRecepcion
    .filter(p => p.tipo === 'original')
    .reduce((sum, p) => sum + p.cantidadOriginal, 0);
  
  const totalProductosRecepcion = productosRecepcion.reduce((sum, p) => sum + p.cantidadRecepcion, 0);
  const productosModificados = productosRecepcion.filter(p => p.modificado || p.tipo === 'nuevo').length;

  if (!devolucion) return null;

  return (
    <div className="modal-overlay modal-recepcion-overlay">
      <div className="modal-content-recepcion modal-recepcion-content">
        <div className="modal-header modal-recepcion-header">
          <div className="header-content">
            <h2>📥 Confirmar Recepción de Devolución</h2>
            <p>Vale: <strong>{devolucion.ID_Vale}</strong> • Cliente: <strong>{devolucion.Cliente}</strong></p>
          </div>
          <button className="btn-cerrar-modal" onClick={onClose}>×</button>
        </div>

        <div className="modal-body modal-recepcion-body">
          {/* Información General */}
          <div className="seccion-info-general modal-info-section">
            <div className="info-grid-modal modal-info-grid">
              <div className="info-item-modal">
                <span className="info-label">📋 Vale:</span>
                <span className="info-value">{devolucion.ID_Vale}</span>
              </div>
              <div className="info-item-modal">
                <span className="info-label">👤 Cliente:</span>
                <span className="info-value">{devolucion.Cliente}</span>
              </div>
              <div className="info-item-modal">
                <span className="info-label">📍 Ruta:</span>
                <span className="info-value">{devolucion.Ruta}</span>
              </div>
              <div className="info-item-modal">
                <span className="info-label">📅 Fecha Ruta:</span>
                <span className="info-value">{new Date(devolucion.Fecha_Ruta).toLocaleDateString()}</span>
              </div>
              <div className="info-item-modal">
                <span className="info-label">🔄 Modificados:</span>
                <span className={`info-value ${productosModificados > 0 ? 'modificado' : ''}`}>
                  {productosModificados} producto{productosModificados !== 1 ? 's' : ''}
                </span>
              </div>
            </div>
          </div>

          {/* Lista de Productos */}
          <div className="seccion-productos-recepcion modal-productos-section">
            <div className="seccion-header modal-section-header">
              <h3>📦 Productos a Recibir</h3>
              <button 
                className="btn-agregar-linea"
                onClick={agregarLinea}
                type="button"
              >
                <span className="btn-icon">➕</span>
                Agregar Producto
              </button>
            </div>
            
            {/* Tabla de Productos */}
            <div className="productos-table-container">
              <table className="productos-table">
                <thead>
                  <tr>
                    <th className="col-acciones">Acciones</th>
                    <th className="col-codigo">Código</th>
                    <th className="col-nombre">Producto</th>
                    <th className="col-cantidad">Cant. Original</th>
                    <th className="col-recepcion">Cant. Recepción</th>
                    <th className="col-lote">Lote</th>
                    <th className="col-motivo">Motivo</th>
                    <th className="col-observaciones">Observaciones</th>
                  </tr>
                </thead>
                <tbody>
                  {productosRecepcion.map((producto, index) => (
                    <tr 
                      key={producto.ID_Devolucion_Detalle} 
                      className={`producto-row ${producto.modificado ? 'modificado' : ''} ${producto.tipo === 'nuevo' ? 'nuevo' : ''}`}
                    >
                      {/* Columna Acciones */}
                      <td className="col-acciones">
                        <div className="acciones-container">
                          {producto.tipo === 'nuevo' && (
                            <button
                              className="btn-eliminar"
                              onClick={() => eliminarLinea(producto.ID_Devolucion_Detalle)}
                              title="Eliminar línea"
                            >
                              🗑️
                            </button>
                          )}
                          {producto.tipo === 'original' && producto.modificado && (
                            <span className="badge-modificado" title="Producto modificado">🔄</span>
                          )}
                        </div>
                      </td>
                      
                      {/* Columna Código */}
                      <td className="col-codigo">
                        {productoEditando === producto.ID_Devolucion_Detalle ? (
                          <div className="autocompletar-modal-container">
                            <AutocompletarProductos
                              value={producto.ID_Producto_Recepcion ? `${producto.ID_Producto_Recepcion} - ${producto.ItemName_Recepcion}` : ''}
                              onChange={() => {}}
                              onSeleccionar={(nuevoProducto) => handleProductoChange(producto.ID_Devolucion_Detalle, nuevoProducto)}
                              mostrarLista={productoEditando === producto.ID_Devolucion_Detalle}
                              onMostrarListaChange={(mostrar) => {
                                if (!mostrar) setProductoEditando(null);
                              }}
                              placeholder="Buscar producto..."
                              productosCatalogo={productosCatalogo}
                            />
                          </div>
                        ) : (
                          <div 
                            className="codigo-container"
                            onClick={() => iniciarEdicionProducto(producto.ID_Devolucion_Detalle)}
                          >
                            <span 
                              className={`codigo-producto ${producto.ID_Producto_Recepcion !== producto.ID_Producto_Original ? 'modificado' : ''}`}
                              title="Haz clic para cambiar el producto"
                            >
                              {producto.ID_Producto_Recepcion}
                            </span>
                            {producto.tipo === 'original' && producto.ID_Producto_Original !== producto.ID_Producto_Recepcion && (
                              <div className="codigo-original">
                                <small>Original: {producto.ID_Producto_Original}</small>
                              </div>
                            )}
                          </div>
                        )}
                      </td>
                      
                      {/* Columna Nombre */}
                      <td className="col-nombre">
                        <div className="nombre-container">
                          <span 
                            className={`nombre-producto ${producto.ItemName_Recepcion !== producto.ItemName_Original ? 'modificado' : ''}`}
                            title={producto.ItemName_Recepcion}
                          >
                            {producto.ItemName_Recepcion}
                          </span>
                          {producto.tipo === 'original' && producto.ID_Producto_Original !== producto.ID_Producto_Recepcion && (
                            <div className="nombre-original">
                              <small>{producto.ItemName_Original}</small>
                            </div>
                          )}
                        </div>
                      </td>
                      
                      {/* Columna Cantidad Original */}
                      <td className="col-cantidad">
                        <span className="cantidad-original">
                          {producto.cantidadOriginal}
                        </span>
                      </td>
                      
                      {/* Columna Cantidad Recepción */}
                      <td className="col-recepcion">
                        <input
                          type="number"
                          min="0"
                          max={producto.tipo === 'nuevo' ? 999 : producto.cantidadOriginal}
                          value={producto.cantidadRecepcion}
                          onChange={(e) => handleCantidadChange(producto.ID_Devolucion_Detalle, e.target.value)}
                          className="input-cantidad"
                          placeholder="Cantidad"
                        />
                      </td>
                      
                      {/* Columna Lote */}
                      <td className="col-lote">
                        <span className="lote-texto">
                          {producto.Lote || "N/A"}
                        </span>
                      </td>
                      
                      {/* Columna Motivo */}
                      <td className="col-motivo">
                        <span
                          className="badge-motivo"
                          style={{
                            backgroundColor: motivosDevolucion[producto.ID_Motivo_Devolucion]?.color + '20',
                            color: motivosDevolucion[producto.ID_Motivo_Devolucion]?.color,
                            border: `1px solid ${motivosDevolucion[producto.ID_Motivo_Devolucion]?.color}`
                          }}
                        >
                          {motivosDevolucion[producto.ID_Motivo_Devolucion]?.texto || `Motivo ${producto.ID_Motivo_Devolucion}`}
                        </span>
                      </td>
                      
                      {/* Columna Observaciones */}
                      <td className="col-observaciones">
                        <input
                          type="text"
                          value={producto.observaciones}
                          onChange={(e) => handleObservacionesChange(producto.ID_Devolucion_Detalle, e.target.value)}
                          placeholder="Escribe observaciones..."
                          className="input-observaciones"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Resumen y Totales */}
            <div className="resumen-totales">
              <div className="totales-grid">
                <div className="total-item">
                  <div className="total-label">📦 Total Original:</div>
                  <div className="total-value">{totalProductosOriginal} unidades</div>
                </div>
                <div className="total-item">
                  <div className="total-label">📥 Total Recepción:</div>
                  <div className="total-value">{totalProductosRecepcion} unidades</div>
                </div>
                <div className="total-item diferencia">
                  <div className="total-label">⚖️ Diferencia:</div>
                  <div className="total-value">
                    {totalProductosRecepcion - totalProductosOriginal} unidades
                  </div>
                </div>
                <div className="total-item modificados">
                  <div className="total-label">🔄 Productos Modificados:</div>
                  <div className="total-value">{productosModificados} items</div>
                </div>
              </div>
            </div>

            {/* Instrucciones */}
            <div className="instrucciones-section">
              <div className="instruccion-item">
                <span className="instruccion-icon">💡</span>
                <span className="instruccion-texto">
                  <strong>Para modificar un producto:</strong> Haz clic en el código del producto para buscar y seleccionar uno diferente
                </span>
              </div>
              <div className="instruccion-item">
                <span className="instruccion-icon">📝</span>
                <span className="instruccion-texto">
                  <strong>Para agregar productos:</strong> Usa el botón "Agregar Producto" para incluir productos adicionales
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer modal-recepcion-footer">
          <button className="btn-cancelar" onClick={onClose} disabled={cargando}>
            <span className="btn-icon">✖️</span>
            Cancelar
          </button>
          <button
            className="btn-confirmar-recepcion"
            onClick={handleConfirmar}
            disabled={cargando || totalProductosRecepcion === 0}
          >
            {cargando ? (
              <>
                <span className="btn-spinner"></span>
                Procesando...
              </>
            ) : (
              <>
                <span className="btn-icon">✅</span>
                Confirmar Recepción ({productosModificados > 0 ? 'Con Cambios' : 'Sin Cambios'})
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalRecepcion;